export default __webpack_public_path__ + "static/media/caixa-assinatura.ceecc631.webp";